enum AdswizzDeviceTypeLabel {
  Phone = 'Phone',
  SmartSpeaker = 'Smart Speaker',
  Desktop = 'Desktop',
  Tablet = 'Tablet',
  SmartTV = 'Smart TV',
  Other = 'Other',
  SmartWatch = 'Smart Watch',
  PortableMediaPlayer = 'Portable Media Player',
  GamingConsole = 'Gaming Console',
  ConnectedVehicle = 'Connected Vehicle',
}

export default AdswizzDeviceTypeLabel;
